module.exports = __webpack_public_path__ + "img/cloudscale.15af4521.svg";